import { render, staticRenderFns } from "./SChip.vue?vue&type=template&id=170ca665&functional=true&"
import script from "./SChip.vue?vue&type=script&lang=js&"
export * from "./SChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports